/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum APITypeEnum {
    Bug = 'Bug',
    Feature = 'Feature',
    General = 'General'
}


export function instanceOfAPITypeEnum(value: any): boolean {
    for (const key in APITypeEnum) {
        if (Object.prototype.hasOwnProperty.call(APITypeEnum, key)) {
            if (APITypeEnum[key as keyof typeof APITypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function APITypeEnumFromJSON(json: any): APITypeEnum {
    return APITypeEnumFromJSONTyped(json, false);
}

export function APITypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): APITypeEnum {
    return json as APITypeEnum;
}

export function APITypeEnumToJSON(value?: APITypeEnum | null): any {
    return value as any;
}

